module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue6_v2.6bbb32aad7991ee6573b0362642e5024.png";